var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-app-bar",
        {
          attrs: {
            "clipped-left": _vm.$vuetify.breakpoint.smAndUp,
            color: "primary",
            app: "",
            height: _vm.NAVBAR_HEIGHT,
            fixed: "",
            "clipped-right": _vm.$vuetify.breakpoint.smAndUp,
            "hide-on-scroll": _vm.scrollOffNavbarEnabled
          }
        },
        [
          _c("v-app-bar-nav-icon", {
            attrs: { dark: "" },
            on: {
              click: function($event) {
                $event.stopPropagation()
                return _vm.toggleSideBar.apply(null, arguments)
              }
            }
          }),
          _vm._v(" "),
          _vm.$vuetify.breakpoint.xs ? _c("v-spacer") : _vm._e(),
          _vm._v(" "),
          _c(
            "v-toolbar-title",
            { staticClass: "pl-1 ml-0 c-toolbar" },
            [
              _vm.$vuetify.breakpoint.xs
                ? _c(
                    "v-layout",
                    { attrs: { row: "", "justify-center": "" } },
                    [
                      _c(
                        "v-flex",
                        { attrs: { xs3: "" } },
                        [
                          _c(
                            "v-avatar",
                            { attrs: { tile: "", width: "90px" } },
                            [
                              _c("v-img", {
                                attrs: {
                                  src: require(`@/assets/engie-logo.svg`),
                                  alt: "Engie"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _c(
                    "v-avatar",
                    { staticClass: "ml-0", attrs: { tile: "", width: "90px" } },
                    [
                      _c("v-img", {
                        attrs: {
                          src: require(`@/assets/engie-logo.svg`),
                          alt: "Engie",
                          height: "32"
                        }
                      })
                    ],
                    1
                  )
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "caption info--text" }, [
            _vm._v("v" + _vm._s(_vm.version))
          ]),
          _vm._v(" "),
          _vm.gitBranch !== "master"
            ? _c("div", { staticClass: "caption info--text" }, [
                _vm._v("\n      [" + _vm._s(_vm.gitBranch) + "]\n    ")
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("v-spacer"),
          _vm._v(" "),
          _vm.$vuetify.breakpoint.xs
            ? _c(
                "v-menu",
                {
                  attrs: {
                    "offset-y": "",
                    origin: "center center",
                    "nudge-bottom": 10,
                    transition: "slide-y-transition",
                    "min-width": 180
                  }
                },
                [
                  _c(
                    "v-btn",
                    { attrs: { icon: "" } },
                    [_c("v-icon", [_vm._v("more_vert")])],
                    1
                  ),
                  _vm._v(" "),
                  _c("c-setting-list")
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.$vuetify.breakpoint.xs
            ? _c(
                "v-toolbar-items",
                { staticClass: "mr-0" },
                [
                  _c("c-entities-selector"),
                  _vm._v(" "),
                  _c("c-notification-list"),
                  _vm._v(" "),
                  _c(
                    "v-menu",
                    {
                      attrs: {
                        "offset-y": "",
                        origin: "center center",
                        "nudge-bottom": 10,
                        transition: "slide-y-transition",
                        "min-width": 58
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "activator",
                            fn: function({ on }) {
                              return [
                                _c(
                                  "v-btn",
                                  _vm._g(
                                    {
                                      staticClass: "c-button-toolbar",
                                      attrs: { text: "", small: "" }
                                    },
                                    on
                                  ),
                                  [
                                    _c(
                                      "v-avatar",
                                      {
                                        attrs: {
                                          size: "30px",
                                          color: "grey lighten-4"
                                        }
                                      },
                                      [
                                        _c("img", {
                                          attrs: {
                                            src: require("@/assets/avatar.png"),
                                            alt: "Profil Setting"
                                          }
                                        })
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        2026291769
                      )
                    },
                    [_vm._v(" "), _c("c-setting-list")],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }